import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import type { SuspendedAlertBody } from '../alertHover.types'
import { suspendedStyles } from './Suspended.styles'

const SuspendedBody: React.FC<{ body: SuspendedAlertBody }> = ({ body }) => {
  const { t } = useTranslation('alerts')

  if (!body) return null

  return (
    <Box sx={suspendedStyles.root}>
      <Typography sx={suspendedStyles.reason}>
        {t(body?.reason ?? 'suspended.defaultReason')}
      </Typography>
    </Box>
  )
}

export default SuspendedBody
